<script>import { createEventDispatcher, onMount } from "svelte";
import { multi } from "../actions/multi";
import { cls } from "../utils/styles";
import { getComponentClasses } from "./theme";
export let value = "";
export let type = "text";
export let inputmode = void 0;
export let id = void 0;
export let actions = void 0;
export let inputEl = null;
export let autocapitalize = void 0;
let className = void 0;
export { className as class };
export let mask = "";
export let replace = "_";
export let accept = "\\d";
let placeholderProp = void 0;
export { placeholderProp as placeholder };
export let disabled = false;
$:
  placeholder = placeholderProp ?? mask;
const settingsClasses = getComponentClasses("Input");
let isFocused = false;
const dispatch = createEventDispatcher();
let backspace = false;
$:
  replaceSet = new Set(replace);
$:
  prev = ((j) => Array.from(mask ?? "", (c, i) => replaceSet.has(c) ? j = i + 1 : j))(0);
$:
  firstPlaceholderPos = [...mask ?? ""].findIndex((c) => replaceSet.has(c));
$:
  acceptRegEx = accept instanceof RegExp ? accept : new RegExp(accept, "g");
function clean(inputValue) {
  const inputMatch = inputValue?.match(acceptRegEx) || [];
  if (inputMatch.length === 0) {
    return [];
  }
  return Array.from(mask, (maskChar) => {
    if (inputMatch[0] === maskChar || replaceSet.has(maskChar)) {
      return inputMatch.shift() ?? maskChar;
    } else {
      return maskChar;
    }
  });
}
function onInput(e) {
  const el = e.currentTarget;
  applyMask(el, mask);
  dispatch("change", { value });
}
function applyMask(el, mask2) {
  if (mask2) {
    const [i, j] = [el.selectionStart, el.selectionEnd].map((i2) => {
      i2 = clean(el.value.slice(0, i2 ?? void 0)).findIndex((c) => replaceSet.has(c));
      return i2 < 0 ? prev[prev.length - 1] : backspace ? prev[i2 - 1] || firstPlaceholderPos : i2;
    });
    value = clean(el.value).join("");
    el.value = value;
    el.setSelectionRange(i, j);
    backspace = false;
  } else {
    value = el.value;
  }
}
$:
  if (inputEl)
    applyMask(inputEl, mask);
onMount(() => {
  if (mask) {
    const initialValue = value;
    value = clean(value).join("");
    if (value != initialValue) {
      dispatch("change", { value });
    }
  }
});
</script>

<input
  {id}
  {value}
  {type}
  {inputmode}
  placeholder={isFocused && mask ? mask : placeholder}
  {disabled}
  {autocapitalize}
  bind:this={inputEl}
  on:keydown={(e) => (backspace = e.key === 'Backspace')}
  on:keydown
  on:keyup
  on:keypress
  on:input={onInput}
  on:input
  on:focus={(e) => {
    isFocused = true;
  }}
  on:focus
  on:blur={(e) => {
    isFocused = false;

    // TODO: Consider clearing value if any mask is still shown?
    // TODO: Dispatch blur as well to allow DateField/etc to do the same if no value is set?
    if (value === mask) {
      value = '';
    }
    dispatch('blur', e);
  }}
  on:blur
  use:multi={actions}
  {...$$restProps}
  class={cls(
    'Input',
    'text-sm w-full outline-none bg-transparent placeholder-surface/50 selection:bg-surface-content/10',
    mask && (mask == placeholder || isFocused || value) && 'font-mono',
    settingsClasses.root,
    className
  )}
/>

<style>
  /* Hide +/- buttons */
  input[type='number'] {
    -webkit-appearance: textfield;
            appearance: textfield;
    -moz-appearance: textfield;
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
</style>
